import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingChat from "./components/FloatingChat";
import CtaBanner from "./components/CtaBanner"; // if you render it anywhere, keep import
import ScrollToTop from "./components/ScrollToTop";
import FloatingBot from "./components/FloatingBot";

// 🔵 AOS site‑wide (init once here)
import AOS from "aos";
import "aos/dist/aos.css";

// 🟣 Slick carousel CSS (global so any page can use it)
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Destinations from "./pages/Destinations";
import Contact from "./pages/Contact";
import StudentVisa500 from "./pages/visa/StudentVisa500";
import TouristVisa600 from "./pages/visa/TouristVisa600";
import SkilledMigration from "./pages/visa/SkilledMigration";
import PostStudyWork485 from "./pages/visa/PostStudyWork485";
import HealthInsurance from "./pages/services/HealthInsurance";
import ProfessionalYear from "./pages/services/ProfessionalYear";
import SkillsAssessment from "./pages/services/SkillsAssessment";
import NewsLanding from "./pages/news/NewsLanding";
import NewsPost from "./pages/news/NewsPost";

// Sub-service Pages
import EducationConsulting from "./pages/services/EducationConsulting";
import VisaAssistance from "./pages/services/VisaAssistance";

function App() {
  useEffect(() => {
    // Init AOS once on app mount
    AOS.init({
      duration: 600,
      offset: 80,
      once: true,
      easing: "ease-out",
    });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/destinations" element={<Destinations />} />
        <Route path="/contact" element={<Contact />} />

        {/* Detailed service pages */}
        <Route path="/services/education-consulting" element={<EducationConsulting />} />
        <Route path="/services/visa-assistance" element={<VisaAssistance />} />

        {/* Visa pages */}
        <Route path="/visa/student-visa-500" element={<StudentVisa500 />} />
        <Route path="/visa/tourist-visa-600" element={<TouristVisa600 />} />
        <Route path="/visa/post-study-work-visa-485" element={<PostStudyWork485 />} />
        <Route path="/visa/skilled-migration" element={<SkilledMigration />} />
        {/* URL alias/redirect for older link */}
        <Route
          path="/visa/skilled-189-190-491"
          element={<Navigate to="/visa/skilled-migration" replace />}
        />

        {/* Services */}
        <Route path="/services/oshc" element={<HealthInsurance />} />
        <Route path="/services/professional-year" element={<ProfessionalYear />} />
        <Route path="/services/skills-assessment" element={<SkillsAssessment />} />

        {/* News */}
        <Route path="/news" element={<NewsLanding />} />
        <Route path="/news/:slug" element={<NewsPost />} />
      </Routes>

      <Footer />
      <FloatingChat />
      <FloatingBot />
    </Router>
  );
}

export default App;
